<template>
  <div class="wrapper">
    <div class="item" v-for="(item,index) in arr" :key="index" @click="toClick(item)">
      <div class="left">
        <img :src="require('../../assets/images/replaceType/'+item.img)" alt />
        <div class="Text">
          <div class="titleBox">
            <span class="title">{{item.title}}</span>
            <div class="freight" v-if="hasBuyPostage&&(item.type=='0'||item.type=='2')">
              <span>运费险</span>
            </div>
          </div>
          <span class="desc">{{item.desc}}</span>
        </div>
      </div>
      <img src="../../assets/images/icon_youjiantou.svg" alt class="right" />
    </div>
  </div>
</template>

<script>
import weChatShareApi from "../../assets/js/weChatShare";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      arr: [
        {
          title: "退货",
          desc: "已收到货且需退货并退款",
          img: "backCommodity.png",
          type: 0
        },
        {
          title: "仅退款",
          desc: "未收到货或者仅需退款",
          img: "backMoney.png",
          type: 1
        },
        {
          title: "换货",
          desc: "收到的商品存在质量问题需要换货",
          img: "changeCommodity.png",
          type: 2
        },
        {
          title: "补偿",
          desc: "收到的商品有缺漏",
          img: "patchPay.png",
          type: 3
        },
        {
          title: "补发",
          desc: "非个人原因造成的商品损失，请与客服协商申请",
          img: "patchSend.png",
          type: 4
        }
      ],
      hasBuyPostage:false,
    };
  },
  methods: {
    initPage() {
      let option = {
        title: "有米@" + this.userInfo.name + "的店铺",
        desc: "欢迎光临我的店铺",
        link: location.origin + "/?supNbr=" + this.userInfo.nbr,
        images: this.userInfo.imgUrl
      };
      this.weChatShare(option);
    },
    toClick(item) {
      this.$router.push({
        path: "/replacement",
        query: {
          nbr: this.$route.query.nbr,
          supNbr: this.userInfo.nbr,
          type: item.type
        }
      });
    }
  },
  created(){
    document.title = "选择类型";
    let type = this.$route.query.type;
    if (type == 1) {
      this.arr = [this.arr[1]];
    } else if (type == 2) {
      this.arr = [this.arr[0], this.arr[1], this.arr[2]];
    } else {
      this.arr = [this.arr[2], this.arr[3], this.arr[4]];
    }

    this.$commonPost({
      jydm: "flow_40005",
      flow_40005: {
        nbr: this.$route.query.nbr
      }
    })
      .then(resp => {
        this.hasBuyPostage = resp.postage_pay&&parseFloat(resp.postage_pay)>0?true:false
      })
      .catch(err => {
        this.$toast({
          message: err.message,
          duration: 2000
        });
      });
  },
  mounted() {
    this.initPage();
  }
};
</script>

<style scoped lang='less'>
.wrapper {
  width: 100%;
  background: #fff;
  min-height: 100vh;
}
.item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.24rem;
  box-sizing: border-box;
  position: relative;
  &::after {
    content: "";
    width: 6.22rem;
    height: 1px;
    background: #eee;
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .left {
    display: flex;
    align-items: center;
    img {
      width: 0.8rem;
      height: 0.8rem;
      margin-right: 0.25rem;
    }
    .Text {
      display: flex;
      flex-direction: column;
      .titleBox{
        display: flex;
        flex-direction: row;
        height: .48rem;
        align-items: center;
      }
      .title {
        color: #333;
        font-size: 0.34rem;
        line-height: 0.48rem;
      }
      .freight{
        width: .76rem;
        height: .32rem;
        border: .01rem solid #FD3535;
        border-radius: .03rem;
        margin-left: .12rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        span{
          font-size: .2rem;
          color: #FD3535;
        }
      }
      .desc {
        color: #999;
        font-size: 0.3rem;
        line-height: 0.42rem;
        width: 5.12rem;
      }
    }
  }
  .right {
    width: 0.4rem;
    height: 0.4rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/information/replaceType.vue